import { render, staticRenderFns } from "./BasalamProductStatus.vue?vue&type=template&id=d479768a&scoped=true"
import script from "./BasalamProductStatus.vue?vue&type=script&lang=js"
export * from "./BasalamProductStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d479768a",
  null
  
)

export default component.exports